module.exports = __webpack_public_path__ + "static/media/time.abd89925.svg";